import { apiInstancePublic } from "../../utils";

interface Response {
  token: string;
}

interface RequestCodePayload {
  email: string;
}

interface ConfirmCodePayload {
  email: string;
  code: string;
  password: string;
  name: string;
}

interface AuthResponse {
  token: string;
  message?: string;
}

export const authByIp = async () => {
  const response = await apiInstancePublic.get<Response>("ip/auth");

  return response.data;
};

export const requestUserCode = async (payload: RequestCodePayload) => {
  const response = await apiInstancePublic.post<{ message: string }>(
    "ip/user/request-code",
    payload,
  );

  return response.data;
};

export const confirmUserCode = async (payload: ConfirmCodePayload) => {
  const response = await apiInstancePublic.post<AuthResponse>(
    "ip/user/confirm-code",
    payload,
  );

  return response.data;
};

export const loginDependentUser = async (email: string, password: string) => {
  const response = await apiInstancePublic.post<AuthResponse>("ip/user/login", {
    email,
    password,
  });

  return response.data;
};

export const sendResetPasswordLink = async (email: string) => {
  const response = await apiInstancePublic.post("ip/user/forgot-password", {
    email,
  });

  return response.status;
};

export const resetPassword = async (token: string, password: string) => {
  const response = await apiInstancePublic.post("ip/user/reset-password", {
    token,
    password,
  });

  return response.status;
};
